export default {
  LandingPage: {
    intro_sub: '버려지는 포장재에 생명을 불어넣어 환경보호에 기여해보세요',
    title: '삼성 업사이클 패키지',
    sequence1_1:
      '갖고 있는 제품 포장재를 활용하여 유용한 생활소품을 만들 수 있습니다',
    sequence1_2:
      '쓰레기를 줄여 환경을 지키는 일에 동참하세요. 스크롤을 내려 시작해보세요',
    sequence2_1: '삼성 업사이클 패키지를 소개합니다',
    sequence2_2:
      '업사이클 패키지는 창의적으로 재사용할 수 있도록 설계된 포장재입니다. 다양한 생활소품으로 업사이클링 할 수 있도록 디자인 되어있어요',
    sequence3_1: '점 패턴이 핵심입니다',
    sequence3_2:
      '골판지 표면에 인쇄된 점 패턴이 핵심입니다. 안내에 따라 놀라운 결과물을 만들어보세요',
    sequence4_1: '만들고 싶은 디자인을 선택해주세요',
    sequence4_2:
      '화면을 아래로 내려 가지고 있는 포장재의 제품을 선택하여 만들 수 있는 다양한 디자인을 확인해보세요. 이제 마음에 드는 디자인을 선택하여 시작해보세요',
    selectBox: '구매한 제품을 선택하세요',
    moreActivity: '삼성의 지속가능한 활동에 대해 더 알아보세요',
    OLED: 'OLED',
    QLED8K: 'QLED', //update
    UHD: 'UHD', //update
    FHD: 'FHD',
    HD: 'HD',
    theFrame: 'The Frame',
    theSerif: 'The Serif',
    theSero: 'The Sero',
    theTerrace: 'The Terrace', //update
    thePremiere: 'The Premiere', //update
    Monitors: 'Monitors', //update
    OdysseyArk:"오디세이 Ark",
    QSoundbar: 'Q Soundbar', //update
    Soundbar: 'Soundbar', //update
    SoundbarSet01:'Soundbar Set 1',
    SoundbarSet02:'Soundbar Set 2',
    TheTerraceSoundbar:'The Terrace Soundbar',
    Soundtower:'Sound Tower',
    BespokeJet: 'BESPOKE 제트\n(제트)',
    BespokeJetStation:'BESPOKE 제트\n(청정스테이션)',
    BespokeJetNCleanStation : 'BESPOKE 제트&\n청정스테이션',
    BespokeJetNCleanStation2 : 'BESPOKE 제트&청정스테이션',
    BespokeCube53:'BESPOKE 큐브™ AIR\n(53㎡)',
    BespokeCube70:'BESPOKE 큐브™ AIR\n(70㎡)',
    BespokeCube106:'BESPOKE 큐브™ AIR\n(106㎡)',
    BespokeCube123:'BESPOKE 큐브™ AIR\n(123㎡)',
    Qooker:'Qooker',
    BespokeSlim:'BESPOKE \n슬림',
    TheFreeStyle:"The Freestyle",
    BespokeSlimCleanStation:"BESPOKE 슬림&삼성 제트\n(청정스테이션)",
    JetCleanStation:"삼성 제트&\n청정스테이션",
    JetCleanStation2:"삼성 제트&청정스테이션",
    BlueSky:"블루스카이 \n5500",
    BlueSky3000:"블루스카이 \n3000",
    BlueSky3100:"블루스카이 \n3100",
    BlueSky5000:"블루스카이 \n5000",
    BespokeJetbot:"BESPOKE\n 제트 봇",
    BespokeJetbot2:"BESPOKE 제트 봇",
    BespokeJetbotPlus:"BESPOKE\n 제트 봇+",
    BespokeJetbotPlus2:"BESPOKE 제트 봇+",
    BespokeJetbotAI:"BESPOKE\n 제트 봇 AI",
    BespokeJetbotAI2:"BESPOKE 제트 봇 AI",
    Canister01:"파워모션 \n01",
    Canister02:"파워모션 \n02",
    Jupiter:"삼성 \n청소기",
    ref_cube:"BESPOKE 큐브 냉장고",
    WaterPurifier:"BESPOKE 정수기",
    LATIN:"LATIN",
    LATIN10:"LATIN10",
    MIRROR:"MIRROR",
    MW5100J:"MW5100J",
    STENA:"STENA",
    // moreActivityLink:
    //   'https://www.samsung.com/sec/sustainability/overview/',
    // moreActivityLink:'https://www.samsung.com/sec/aboutsamsung/sustainability/strategy/',
    moreActivityLink: 'https://www.samsung.com/sec/sustainability/overview/',
    footer: 'Copyright © 2019-2021 SAMSUNG All Rights Reserved',

    // "경기도 수원시 영통구 삼성로 129 (매탄동) 삼성전자주식회사 대표이사 김기남 사업자등록번호 124-81-00998 사업자 정보확인 통신판매업<br/>
    // 대표번호: 02-2255-0114 팩스: 02-2255-0117 제품/서비스: 1588-3366 구매문의: 1588-6084<br/>
    // 삼성전자주식회사는 통신판매중개자로서 통신판매의 당사자가 아니며, 개별 판매자가 등록한 거래정보 및 거래에 대하여 책임을 지지 않습니다.<br/>
    // 본 사이트의 콘텐츠는 저작권법의 보호를 받는바, 무단 전재, 복사, 배포 등을 금합니다.<br/>`"
  },
  ProductPage: {
    selectDesign: '디자인을 선택하세요',
    selectDesignDezeen: 'Samsung X Dezeen', //update
    selectDesignSoccer: 'Samsung X Football', 
    tvConsole: 'TV 콘솔',
    StorageBox: '수납함',
    MagazineRack: '잡지 수납함',
    CatHouse: '고양이 집',
    CatTunnel: '고양이 터널',
    BookShelf: '책꽂이',
    DeskShelf: '탁상 선반',
    BlackRhino: 'Endangered \n Animals \n Black Rhino', //update
    PolarBear: 'Endangered \n Animals \n Polar Bear', //update
    SeaTurtle: 'Endangered \n Animals \n Sea Turtle', //update
    TheRider: 'The Rider', //update
    Kibe: 'Kibe', //update
    Tessellate: 'Tessellate', //update
    Twist: 'Twist', //update
    AlexCouchArmTable: 'Alex Couch \n Arm Table', //update
    BlastOffClubHouse: 'Blast Off \n Club House', //update
    KinokoTable: 'Kinoko table', //update
    Magnuss: 'Magnuss', //update
    GIO: 'Gio', //update
    PostCardPlanter: 'Postcard \n Planter', //update
    SneakerRack: 'Sneaker \n Rack', //update
    TheSoban: 'The Soban', //update
    ToolBox: 'Tool Box', //update
    DeskStationary: '문구 수납합',
    CoinBank: '저금통',
    MobileScanner:'스마트폰 스캐너 스탠드',
    TabletScanner:'태블릿 스캐너 스탠드',
    PetStairs:'반려동물 계단',
    PetFurniture: 'Pet Friendly Furniture',
    ShoeRackA:'Shoe Rack_A',
    ShoeRackB:'Shoe Rack_B',
    WineRackDog:'Wine Rack Dog',
    WineRack:'Wine Rack',
    mins: '분',
    all:'전체',
    in: '인치',
    inOnly: '인치만 가능',
    allBoxSize: '모든 인치 가능',
    soccergoalpost:'Mini Soccer Goal Post',
   soccerboard:'Table Soccer Board',
   sixpackcarrier:'Six Pack Carrier',
   trophytable:'Trophy Cup Table',
   megaphone:'Cheer Megaphone',
   FreestyleBear:'Small \n Animals \n Polar Bear',
   FreestyleRay:'Small \n Animals \n Ray',
   FreestyleRhino:'Small \n Animals \n Black Rhino',
   FreestyleSeahorse:'Small \n Animals \n See Horse',
   FreestyleWhale:'Small \n Animals \n Whale',
   Mickey:'Mickey Mouse',
   Pluto:'Pluto',
   Diseny:'Samsung X Disney'
  },
  DetailGuidePage: {
    1:'1',
    2:'2',
    3:'3',
    instructions: '제작방법',
    prepare: '상자를 준비해 주세요',
    LetsDesign: '만들어 볼까요?',
    drawParts: '상자 위에 구성품을 그려보세요',
    note1: '그래픽 위치는 국가 및 상자 크기에 따라 다를 수 있습니다',
    note2: '전체 도면이 상자에 들어가도록 먼저 스케치하세요',
    numberSpace: '숫자 = 점 사이의 공간',
    diagonal: '대각선',
    LEFT: '좌측면',
    RIGHT: '우측면',
    TOP: '상단면',
    TOP1: '상단면 1',
    TOP2: '상단면 2',
    BACK: '후면',
    MIDDLE: '중간면',
    MIDDLE2: '중간면 2',
    BOTTOM: '하단면',
    FRONT: '전면',
    SIDE: '측면',
    secondSIDE: '두번째 측면',
    secondSIDE1: '두번째 측면 1',
    secondSIDE2: '두번째 측면 2',
    LEG: '다리', //update
    JOINT: '연결부위', //update
    FACE: '얼굴', //update
    DRAWERBOTTOM: '서랍하단면', //update
    DRAWERSIDE: '서랍측면', //update
    NOSE: '앞코', //update
    HANDLE: '손잡이', //update
    BOTTOMSIDE: '하단측면', //update
    TOPSIDE: '상단측면', //update
    WING: '날개', //update
    cutAndAssemble: '자르고 조립해봅시다',
    beCareful: '칼을 사용할 때 다치지 않도록 주의하세요',
    cutOutParts: '구성품을 잘라주세요',
    assemble: '조립하세요',
    Assemblyguide: '조립 가이드',
    fold: '접는 예',
    foldGuide: '골판지를 접을 때 가구의 모서리를 활용하세요',
    foldGuideDezeen:
      '도구를 이용하여 점선을 따라 접는 선을 여러 번 만들어 주세요', //update
    glue: '테이프나 접착제를 표면에 고르게 붙여주세요', //update
    cable: '케이블타이나 줄을 이용하여 연결하세요', //update
    done: '완성했습니다!',
    goBack: '메인메뉴로 돌아가기',
  },
  CautionPage: {
    CAUTION: '주의사항',
    needItem: '그림과 같은 도구들이 필요합니다',
    children: '어린이들은 반드시 어른들과 함께 진행해주세요',
    mat: '제작 중 바닥에 흠집이 나지 않도록 보호 매트를 깔아주세요',
    doNotPutHeavyThing:
      '가구를 밟거나 가구위에 앉지 마시고 무거운 물건을 올려 놓지 마세요',
    doNotThrow: '사람이나 동물 등을 향해 가구를 던지거나 발로 차지 마세요',
    stayAwayFlame: '화기에 가까이 하지 마세요',
    stayAwayWater: '가구를 물이나 습기로부터 멀리하세요',
    mayDamaged: 'TV상자는 배송 과정 중 손상을 입을 수 있습니다.',
    companyDoestResponsible:
      '회사는 가구 제작 과정 중 발생하는 파손이나 부상에 대해 일체 책임지지 않습니다.',
    cannotBeReturned:'',
    understand: '네, 이해했습니다',
  },
  PrivacyPolicy: {
    title: '개인정보처리방침',
  },
  GoingGreen: {
    visual: {
      title: 'Going Green',
      text1:
        '우리의 새로운 포장재는 이전보다 종이와 잉크를 적게 사용하여 지속가능성에 대한 약속을 지키고 있습니다',
      text2:
        '',
      text2_special:'',
      text3: '자세히 알아보려면 아래 버튼을 선택하세요',
    },
    greenIn: {
      title: 'TV 패키지에서의 Going Green',
      subtitle1: '잉크를 사용하지 않는 제품 정보',
      subtitle2: '업사이클링 에코패키지',
      desc: '모델 명을 검색해 더 많은 정보를 찾아보세요',
      descM: '*Take a photo of the TV model number',
      guide: '모델명',
      button: 'Take Photo',
      button2: '만들어보기',
      product_info: 'Product Info',
    },
    search: {
      guide: 'Search..',
      noResult: '검색 결과없음',
      more: '더 알아보기',
      search: 'Search',
      retake: 'Retake',
      result: 'Result',
    },
    photo: {
      guide1: 'Place TV model name in the box',
      guide2: '(e.g. Q800A, UT7000, RU7100, etc)',
    },
  },
  searchCountrySelect: '검색 할 국가를 선택하세요'
};
